// extracted by mini-css-extract-plugin
module.exports = {"root":"CompanyBinds_root__2Z2w0"};